import state from '@/store/modules/auctions/defaultState';

const actions = {
  getMyAcvPendingProxyAuctions(
    {
      dispatch,
    },
    { page = 1 },
  ) {
    return dispatch('getAuctionList', {
      apiMethod: 'getMyAcvPendingProxyAuctions',
      moduleKey: 'MyAcvPendingProxy',
      numberOfLoaders: 10,
      page,
    });
  },
};

export default {
  state,
  actions,
};
